import React from "react";
import "./style.css";
import Card from "../../components/Widgets/Card";
import WishlistGrid from "../../components/Widgets/grid";
import Grid from '@material-ui/core/Grid';
// import SectionHeading from "../../components/Widgets/section-head";
import { connect } from "react-redux";
import Banner from "../../components/Widgets/Banner";

const Wishlist = ({ wishlist, addToCart, removeFromWish }) => {
    const CardGrid = () => {
        let count = 0;
        const data = wishlist?.map(item => {
            count++;
            return (
                <Grid style={{}} key={count} item xs={10} sm={5} md={3} lg={3} xl={2} className="grid-item">
                    <Card 
                        // @ts-ignore
                        className="product-card"
                        key={item.id}
                        data={item}
                        addToCart={ addToCart }
                        removeFromWish={ removeFromWish }
                        deleteIcon = { true }
                         />
                </Grid>
            )
        }) ?? "";
        return data;
    }

    return (
        <div className="products-container">
            <Banner route="wishlist">

            </Banner>
            <WishlistGrid>
                <CardGrid />
            </WishlistGrid>
            
        </div>
    )
    
}

const matchStateToProps = (state) => {
    return {
      basket: state.basket,
      wishlist: state.wishlist
    }
}

const matchDispatchToProps = (dispatch) => {
    return{
        removeFromWish: (id) => dispatch({ type: "REMOVE_FROM_WISH", id }),
        addToCart: (item) => dispatch({ type: "ADD_TO_CART", item })
    }
  }

export default connect(matchStateToProps, matchDispatchToProps)(Wishlist);